"use strict";
exports.__esModule = true;
var constant_1 = require("./constant");
function execRegex(value, regex) {
    var _a;
    var isPreDefinedRegex = typeof regex === 'string';
    var $regex;
    if (isPreDefinedRegex) {
        if (constant_1["default"][regex]) {
            $regex = constant_1["default"][regex];
        }
    }
    else if (regex === null || regex === void 0 ? void 0 : regex.pattern) {
        var pattern = regex.pattern, flags = regex.flags;
        $regex = new RegExp(pattern, flags);
    }
    else if (regex === null || regex === void 0 ? void 0 : regex.exec) {
        $regex = regex;
    }
    return ((_a = value === null || value === void 0 ? void 0 : value.match($regex)) === null || _a === void 0 ? void 0 : _a[0]) || null;
}
exports["default"] = execRegex;
